var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { differenceInCalendarDays } from 'date-fns';
var FULL_RANGE_USERS = [
    {
        email: 'anna.kowalska@company.com',
        name: 'Anna Kowalska',
        avatar: 'https://i.pravatar.cc/150?img=5',
        userId: 'user_1',
        orgUnitTitle: 'Finance',
        views: 32,
        edits: 15,
        downloads: 6,
        prints: 8,
        commentsPosted: 2,
        commentsResolved: 6,
        suggestionsPosted: 4,
        suggestionsResolved: 1,
        sharedInternally: 2,
        sharedExternally: 5,
        sharedPublicly: 1
    },
    {
        email: 'john.smith@company.com',
        name: 'John Smith',
        avatar: 'https://i.pravatar.cc/150?img=1',
        userId: 'user_2',
        orgUnitTitle: 'Ops',
        views: 28,
        edits: 10,
        downloads: 4,
        prints: 5,
        commentsPosted: 3,
        commentsResolved: 4,
        suggestionsPosted: 2,
        suggestionsResolved: 2,
        sharedInternally: 1,
        sharedExternally: 2,
        sharedPublicly: 0
    },
    {
        email: 'emma.wilson@company.com',
        name: 'Emma Wilson',
        avatar: 'https://i.pravatar.cc/150?img=2',
        userId: 'user_3',
        orgUnitTitle: 'HR',
        views: 19,
        edits: 6,
        downloads: 2,
        prints: 3,
        commentsPosted: 1,
        commentsResolved: 2,
        suggestionsPosted: 1,
        suggestionsResolved: 0,
        sharedInternally: 0,
        sharedExternally: 1,
        sharedPublicly: 0
    }
];
var scaleMetric = function (value, factor) {
    return Math.round(value * factor);
};
export var drivePeopleActivity = function (input) {
    var dateFrom = new Date(input.dateFrom);
    var dateTo = new Date(input.dateTo);
    var rangeDays = Math.max(differenceInCalendarDays(dateTo, dateFrom) + 1, 1);
    var factor = Math.min(rangeDays / 30, 1);
    var users = FULL_RANGE_USERS.map(function (user) { return (__assign(__assign({}, user), { views: scaleMetric(user.views, factor), edits: scaleMetric(user.edits, factor), downloads: scaleMetric(user.downloads, factor), prints: scaleMetric(user.prints, factor), commentsPosted: scaleMetric(user.commentsPosted, factor), commentsResolved: scaleMetric(user.commentsResolved, factor), suggestionsPosted: scaleMetric(user.suggestionsPosted, factor), suggestionsResolved: scaleMetric(user.suggestionsResolved, factor), sharedInternally: scaleMetric(user.sharedInternally, factor), sharedExternally: scaleMetric(user.sharedExternally, factor), sharedPublicly: scaleMetric(user.sharedPublicly, factor) })); });
    var totals = users.reduce(function (acc, user) { return ({
        views: acc.views + user.views,
        edits: acc.edits + user.edits,
        downloads: acc.downloads + user.downloads,
        prints: acc.prints + user.prints,
        commentsPosted: acc.commentsPosted + user.commentsPosted,
        commentsResolved: acc.commentsResolved + user.commentsResolved,
        suggestionsPosted: acc.suggestionsPosted + user.suggestionsPosted,
        suggestionsResolved: acc.suggestionsResolved + user.suggestionsResolved,
        sharedInternally: acc.sharedInternally + user.sharedInternally,
        sharedExternally: acc.sharedExternally + user.sharedExternally,
        sharedPublicly: acc.sharedPublicly + user.sharedPublicly
    }); }, {
        views: 0,
        edits: 0,
        downloads: 0,
        prints: 0,
        commentsPosted: 0,
        commentsResolved: 0,
        suggestionsPosted: 0,
        suggestionsResolved: 0,
        sharedInternally: 0,
        sharedExternally: 0,
        sharedPublicly: 0
    });
    return {
        total: users.length,
        users: users,
        totals: totals
    };
};
